// This is generated.  Alter it in blockGroups/lists/types/CardList.js
/* eslint-disable no-unused-vars */
const { actionUtils } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context,
    parentAccessRestrictions,
  ) {
    const { namespace, relation, children, securityModifier } = hNode;

    const accessRestrictions = actionUtils.getNodeAccessRestrictions(
      hNode,
      context,
      parentAccessRestrictions,
    );
    const normalizedAction = actionUtils.normalizeAction('list');

    if (accessRestrictions.hidden) return [{}, {}];

    let [_subDataDictionary = {}, _partialTypeDefinition = {}] = (
      children || []
    ).reduce(
      ([sdd, ptd], child) => {
        const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
          context.extractFromChild(child, context, accessRestrictions);
        return [
          moduleRegistration.mergeSubDataDictionaries(sdd, _subDataDictionary),
          moduleRegistration.mergePartialTypeDefinitions(
            ptd,
            _partialTypeDefinition,
            context,
          ),
        ];
      },
      [{}, {}],
    );

    // Build relation entry for route access checks
    // Note: This is a view-only block so we don't set required - that's defined by Forms
    const relationSchema = {
      type: 'object',
      properties: { ..._partialTypeDefinition },
      'x-accessRestrictions': accessRestrictions,
      'x-forAction': normalizedAction,
    };

    // Use relation-aware merge to avoid overwriting canonical required arrays
    const subDataDictionary = moduleRegistration.mergeSubDataDictionaries(
      {
        [namespace]: {
          [relation]: relationSchema,
        },
      },
      _subDataDictionary,
    );

    return [subDataDictionary, {}];
  },
};
moduleRegistration.registerHNodeType('lists', 'CardList', module.exports);
